import React, { ReactElement } from 'react';
import styled from 'styled-components';

import { FjCheckbox } from 'components/primitives';
import { Label, InputContainer } from './index';

const Checkbox = styled(FjCheckbox).attrs(({ theme }) => ({
  type: 'radio',
  labelColor: theme.colors.black,
}))``;

interface Radio {
  id: string | number;
  label: string;
}

interface ModalRadioGroupProps {
  selected?: { id: string | number } | null;
  validator?: () => boolean;
  title?: string;
  className?: string;
  name?: string;
  onChange: (radio: Radio) => void;
  radios: Radio[];
  validatorMessage?: string;
}

const ModalRadioGroup = ({
  selected,
  validator = () => true,
  title = '',
  className = '',
  name,
  onChange,
  radios,
  validatorMessage,
}: ModalRadioGroupProps): ReactElement => {
  const isRadioSelected = (radio: Radio): boolean => selected?.id === radio.id;
  const renderLabel = (text: string): ReactElement => <span>{text}</span>;
  const renderValidation = (): true | ReactElement =>
    validator() ? true : <div className="error-red margin-top-med">{validatorMessage}.</div>;

  return (
    <InputContainer>
      <Label>{title}</Label>
      <div className="display-flex flex-fit">
        {radios.map((radio) => (
          <Checkbox
            className={className}
            name={name}
            label={renderLabel(radio.label)}
            checked={isRadioSelected(radio)}
            onChange={() => onChange(radio)}
            key={radio.label}
            data-testid={`modal-radio-${radio.label}`}
          />
        ))}
      </div>
      {renderValidation()}
    </InputContainer>
  );
};

export default ModalRadioGroup;
